import { useQuery } from '@tanstack/react-query';

import { axios } from '@/src/lib/axios/axios';
import { QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { PROJECT_BASE_URL } from '../../api/config';
import { LibraryUserAccessDTO } from '../types';

export type GetLibraryMembersResponse = {
  status: boolean;
  data: {
    'ordered-members': LibraryUserAccessDTO[];
    'ordered-allowed-users': LibraryUserAccessDTO[];
  };
};

export type RawGetLibraryMembersDTO = {
  status: boolean;
  data: {
    'ordered-members': LibraryUserAccessDTO[];
    'ordered-allowed-users': LibraryUserAccessDTO[];
  };
};

export type GetLibraryMembersDTO = {
  projectId: number;
};

export const getLibraryMembersQueryKey = {
  list: ['getLibraryMembers'] as const,
};

const url = `${PROJECT_BASE_URL}/library/members`;

export const getLibraryMembers = async ({
  projectId,
}: GetLibraryMembersDTO): Promise<GetLibraryMembersResponse> => {
  const URL = generateRoutePath(url, { projectId });

  const raw = await axios.get<{
    status: boolean;
    data: {
      'ordered-project-members': LibraryUserAccessDTO[];
      'ordered-allowed-users': LibraryUserAccessDTO[];
    };
  }>(URL);

  return {
    status: raw.data.status,
    data: {
      'ordered-members': raw.data['ordered-project-members'],
      'ordered-allowed-users': raw.data['ordered-allowed-users'],
    },
  };
};
type QueryFnType = typeof getLibraryMembers;

type UseGetLibraryMembersOptions = {
  projectId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetLibraryMembers = ({ projectId, config }: UseGetLibraryMembersOptions) => {
  return useQuery({
    queryKey: [...getLibraryMembersQueryKey.list, projectId],
    queryFn: () => getLibraryMembers({ projectId }),
    // staleTime: Infinity,
    // cacheTime: 0,
    ...config,
  });
};
